import { HttpClient } from "@angular/common/http";
import { Component, OnInit, OnDestroy, ViewChild, ViewChildren, AfterViewInit, QueryList } from "@angular/core";
import { v4 as uuid4 } from "uuid";
import { AuctionFilter } from '../../models/auction-filter';
import { BusAuctionFilterService } from '../../services/bus-auction-filter.service';
import { DataTableDirective } from 'angular-datatables';
import { skip } from "rxjs/operators";

import { DistributorFilter } from '../../models/distributor-filter';
import { environment } from '../../../../../environments/environment';
import { LoggingService } from '../../../../services/logging.service';


const API_SERVER = environment.apiServer;
const MODULE_PATH = "TakomaClient.app.modules.home.components.home-main-modal-member";


declare var $: any;

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}

@Component({
  selector: 'app-home-main-modal-member',
  templateUrl: './home-main-modal-member.component.html',
  styleUrls: ['./home-main-modal-member.component.sass']
})
export class HomeMainModalMemberComponent implements OnInit, OnDestroy, AfterViewInit {

  private subs: any[] = [];

  @ViewChild(DataTableDirective) datatableElement: DataTableDirective;
  @ViewChildren('nameInput') nameInputModel: QueryList<any>;

  checkedDistributerMember: number[];

  dt: DataTables.Api;
  modelDistributorFilter: DistributorFilter = new DistributorFilter();
  modelAuctionFilter: AuctionFilter = new AuctionFilter();
  dtOptionsDistributorMembers: DataTables.Settings = {};
  dataSetDistributors: any;

  constructor(private http: HttpClient, private bus: BusAuctionFilterService, private loggingService: LoggingService) {
    this.checkedDistributerMember = [];
  }

  ngOnInit() {
    this.subs.push(
      this.bus.currentClearModalFilter$
        .pipe(skip(1))  // При инициализации фильтр уже очищен
        .subscribe(key => {
          if (key === 'distrMember' || key === "all") {
            this.nameInputModel.forEach(function (item) {
              item.nativeElement.checked = false;
            });
            this.checkedDistributerMember = [];

            if (key !== "all") {
              this.onAuctionFilter('member');
            }
          }
        })
    );

    this.subs.push(this.bus.currentClearSearchModalFields$.subscribe(key => {
      if (key === 'modalDistributorMember') {
        console.log(key);
        this.modelDistributorFilter.name = null;
        this.onFieldChange();
      }
    }));

    const that = this;
    this.dtOptionsDistributorMembers = {
      pagingType: 'full_numbers',
      pageLength: 100,
      serverSide: true,
      processing: true,
      autoWidth: false,
      dom: 'tip',
      order: [1],
      deferLoading: 0,
      // scrollY: '400px',
      language: {
        emptyTable: 'Нет данных',
        info: 'Отображено с _START_ по _END_ из _TOTAL_ записей',
        infoEmpty: 'Отображено с 0 по 0 из 0 записей',
        infoFiltered: '(отфильтровано из _MAX_ записей)',
        infoPostFix: '',
        thousands: ',',
        lengthMenu: 'Показывать по _MENU_ записей',
        loadingRecords: 'Загрузка ...',
        processing: 'Обработка ...',
        search: 'Поиск:',
        zeroRecords: '',
        paginate: {
          first: 'Первая',
          last: 'Последняя',
          next: 'След.',
          previous: 'Пред.'
        },
        aria: {
          sortAscending: ': activate to sort column ascending',
          sortDescending: ': activate to sort column descending'
        }
      },
      ajax: (dataTablesParameters: any, callback) => {

        dataTablesParameters.search = this.modelDistributorFilter.name;

        that.http.post<DataTablesResponse>(`${API_SERVER}/distributor`, dataTablesParameters, {})
          .subscribe(resp => {
            that.dataSetDistributors = resp.data;
            callback({
              recordsTotal: resp.recordsTotal,
              recordsFiltered: resp.recordsFiltered,
              data: []
            });
          });
      },
      columns: [
        { orderable: false },
        { data: 'distrName', name: 'distrName' },
      ]
    };

  }

  ngOnDestroy() {
    this.subs.forEach(sub => sub.unsubscribe());
  }

  onFieldChange(): void {
    const xid = uuid4();
    const qualName = `${MODULE_PATH}.HomeMainModalMemberComponent.onFieldChange`;
    const inputParams = { };
    const description = "[AJAX] Обработка изменения фильтра дистрибьютора-участника";
    
    try {
      this.loggingService.logStart(xid, qualName, inputParams, description);
      
      this.dt.ajax.reload();
      
      this.loggingService.logFinish(xid, qualName, inputParams, description);
    } catch (error) {
      this.loggingService.logError(xid, qualName, error, inputParams, description);
      throw error;
    }
  }

  onSelectedRowMember(event, value) {
    const xid = uuid4();
    const qualName = `${MODULE_PATH}.HomeMainModalMemberComponent.onSelectedRowMember`;
    const inputParams = { "event": event, "value": value };
    const description = "Обработка выбора дистрибьютора-участника";
    
    try {
      this.loggingService.logStart(xid, qualName, inputParams, description);
      
      if (event.target.checked) {
        this.checkedDistributerMember.push(value);
      } else {
        for (let i = 0; i < this.checkedDistributerMember.length; i++) {
          if (this.checkedDistributerMember[i] === value) {
            this.checkedDistributerMember.splice(i, 1);
          }
        }
      }
      
      this.loggingService.logFinish(xid, qualName, inputParams, description);
    } catch (error) {
      this.loggingService.logError(xid, qualName, error, inputParams, description);
      throw error;
    }
  }

  onSelectingRowsMember(event): void {
    const xid = uuid4();
    const qualName = `${MODULE_PATH}.HomeMainModalMemberComponent.onSelectingRowsMember`;
    const inputParams = { "event": event };
    const description = "Обработка выбора всех дистрибьюторов-участников";
    
    try {
      this.loggingService.logStart(xid, qualName, inputParams, description);

      this.nameInputModel.forEach(
        item => {
          item.nativeElement.checked = event.target.checked;

          if (event.target.checked) {
            this.checkedDistributerMember.push(item.nativeElement.value);
          } else {
            for (let i = 0; i < this.checkedDistributerMember.length; i++) {
              if (this.checkedDistributerMember[i] === item.nativeElement.value) {
                this.checkedDistributerMember.splice(i, 1);
              }
            }
          }
        }
      );
      
      this.loggingService.logFinish(xid, qualName, inputParams, description);
    } catch (error) {
      this.loggingService.logError(xid, qualName, error, inputParams, description);
      throw error;
    }
  }

  onAuctionFilter(selectedType: string) {
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Components.HomeMainModalMemberComponent.onAuctionFilter', null, 'Auction filter started');
      
      switch (selectedType) {
        case 'member':
          {
            this.modelAuctionFilter.distrMember = this.checkedDistributerMember.join(",");
            break;
          }
      }

      this.bus.changeFilter(this.modelAuctionFilter);
      
      this.loggingService.logFinish(_xid, 'App.Components.HomeMainModalMemberComponent.onAuctionFilter', null, 'Auction filter completed');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.HomeMainModalMemberComponent.onAuctionFilter', _error, null, 'Auction filter failed');
      throw _error;
    }
  }

  ngAfterViewInit(): void {
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      this.dt = dtInstance;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/home/components/home-main-modal-member/home-main-modal-member.component.ts